module.exports = __webpack_public_path__ + "static/media/welcome.c59ccf75.svg";